import React from "react";

export default function NotFound() {
  return (
    <div>
      <h1>404</h1>
      <h3>This page does not exist</h3>
    </div>
  );
}
